module.exports = __webpack_public_path__ + "static/media/LoginBack.65317f35.jpg";